import React from 'react';

const QuoteStrip = ({ quote }) => {
  if (!quote || typeof quote !== 'string') return null;
  return (
    <div className="quote-strip" role="complementary" aria-label="Inspirational quote">
      <p className="quote-strip__text">{quote}</p>
    </div>
  );
};

export default QuoteStrip;
